export default __webpack_public_path__ + "static/media/cancel.1ed22ee9.svg";